var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWasteToEnergyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.095,
    height: 38.095,
    viewBox: "0 0 38.095 38.095",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-waste-to-energy-3308013",
    transform: "translate(-16 -15.543)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 1,
    cy: 0.5,
    rx: 1,
    ry: 0.5,
    transform: "translate(20.095 49.543)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9595",
    "data-name": "Path 9595",
    d: "M17.883,230.9v3.766a.628.628,0,0,0,.125.377l1.758,2.343v1.937a3.138,3.138,0,0,0,1.255,6.014h8.16a.628.628,0,0,0,.628-.628V229.648h1.883v-1.255H29.809v-.628a.628.628,0,0,0-.628-.628H27.3v-1.255a.628.628,0,0,0-.475-.609L21.8,224.018a.627.627,0,0,0-.691.286l-1.7,2.834H17.883a1.883,1.883,0,1,0,0,3.766Zm1.255,11.3a1.883,1.883,0,1,1,1.883,1.883,1.883,1.883,0,0,1-1.883-1.883Zm4.392,1.883a3.137,3.137,0,0,0-2.509-5.021V237.18a.628.628,0,0,0-.125-.377l-1.758-2.343V230.9h5.389l1.071,1.072a.628.628,0,0,0,.444.184h2.511v11.926Zm-1.582-18.736,4.095,1.024v.765H20.875Zm-4.065,3.044h10.67V230.9H26.3l-1.071-1.072a.628.628,0,0,0-.444-.184h-6.9a.628.628,0,0,1,0-1.255Z",
    transform: "translate(0 -191.702)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3793",
    "data-name": "Rectangle 3793",
    width: 1,
    height: 2,
    transform: "translate(38.095 15.543)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3794",
    "data-name": "Rectangle 3794",
    width: 1.255,
    height: 1.883,
    transform: "matrix(0.924, -0.383, 0.383, 0.924, 32.251, 17.364)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3795",
    "data-name": "Rectangle 3795",
    width: 1.255,
    height: 1.883,
    transform: "translate(27.5 20.833) rotate(-45)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3796",
    "data-name": "Rectangle 3796",
    width: 1.255,
    height: 1.883,
    transform: "translate(24.439 25.857) rotate(-67.5)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3797",
    "data-name": "Rectangle 3797",
    width: 2,
    height: 1,
    transform: "translate(24.095 30.543)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3798",
    "data-name": "Rectangle 3798",
    width: 1.255,
    height: 1.883,
    transform: "translate(47.473 40.806) rotate(-45)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3799",
    "data-name": "Rectangle 3799",
    width: 1.255,
    height: 1.883,
    transform: "matrix(0.383, -0.924, 0.924, 0.383, 50.534, 36.666)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3800",
    "data-name": "Rectangle 3800",
    width: 2,
    height: 1,
    transform: "translate(52.095 30.543)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3801",
    "data-name": "Rectangle 3801",
    width: 1.883,
    height: 1.255,
    transform: "translate(50.534 25.418) rotate(-22.5)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3802",
    "data-name": "Rectangle 3802",
    width: 1.883,
    height: 1.255,
    transform: "translate(47.473 21.277) rotate(-45)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3803",
    "data-name": "Rectangle 3803",
    width: 1.883,
    height: 1.255,
    transform: "translate(43.06 18.623) rotate(-67.5)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9596",
    "data-name": "Path 9596",
    d: "M232.628,169.416H232v1.255h.628a5.655,5.655,0,0,0,5.649-5.649v-2.878l1.439,1.439.888-.888-2.511-2.511a.628.628,0,0,0-.888,0l-2.511,2.511.888.888,1.439-1.439v2.878A4.4,4.4,0,0,1,232.628,169.416Z",
    transform: "translate(-199.053 -132.725)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9597",
    "data-name": "Path 9597",
    d: "M163.925,56h0A11.915,11.915,0,0,0,152,67.872c0,.238.005.479.018.716l1.254-.069c-.012-.212-.017-.428-.016-.642a10.67,10.67,0,1,1,16.753,8.816,6.887,6.887,0,0,0-2.916,5.041h-6.334a7,7,0,0,0-2.956-5.07c-.2-.139-.394-.287-.583-.439l-.789.976c.21.17.429.335.651.491a5.724,5.724,0,0,1,2.451,4.67v5.021a.624.624,0,0,0,.067.28h0l1.255,2.511a.628.628,0,0,0,.561.347h5.021a.628.628,0,0,0,.561-.347l1.255-2.511h0a.624.624,0,0,0,.067-.28V82.362a5.641,5.641,0,0,1,2.405-4.638A11.926,11.926,0,0,0,163.925,56Zm3.138,28.42-6.277,2.092V85.325l6.277-2.092Zm0,1.323v1.012h-3.036Zm-3.24-2.754L160.787,84V82.99Zm2.225,6.277H161.8l-.628-1.255h5.5Z",
    transform: "translate(-125.329 -36.884)",
    fill: "#404040"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWasteToEnergyIcon);
export default __webpack_public_path__ + "static/media/waste-to-energy-icon.2517b74a1ab1ade9c54f73b1bc2a0225.svg";
export { ForwardRef as ReactComponent };